import { styled } from "@mui/material/styles";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { Dayjs } from "dayjs";

interface CustomPickerDayProps extends PickersDayProps<Dayjs> {
  dayIsBetween: boolean;
  isFirstDay: boolean;
  isLastDay: boolean;
}

const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) => {
    return (
      prop !== "dayIsBetween" && prop !== "isFirstDay" && prop !== "isLastDay"
    );
  },
})<CustomPickerDayProps>(({ theme, dayIsBetween, isFirstDay, isLastDay }) => {
  return {
    ...(dayIsBetween && {
      borderRadius: "50%",
      backgroundColor: `${(theme as OLTheme).primary100} !important`,
    }),
    ...(isFirstDay && {
      borderTopLeftRadius: "50%",
      backgroundColor: `${(theme as OLTheme).primary500} !important`,
      borderBottomLeftRadius: "50%",
      color: `${(theme as OLTheme).white50}`,
    }),
    ...(isLastDay && {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%",
      backgroundColor: `${(theme as OLTheme).primary500} !important`,
      color: `${(theme as OLTheme).white50}`,
    }),
  };
}) as React.ComponentType<CustomPickerDayProps>;

export default CustomPickersDay;
